import type { ActivityIntent, ActivitySection } from '../activity-journal';

export function activityActionFailureMessage(
    actionType: ActivityIntent['type'] | undefined
): string {
    return actionType === 'download-selected-export' ||
        actionType === 'download-export' ||
        actionType === 'download-pack-export'
        ? 'ZIP download failed. Try again.'
        : 'Unable to open this activity. Try again.';
}

export function activityPreviewTitle(
    section: ActivitySection,
    skipped: boolean
): string {
    if (skipped) return 'Document preview skipped';
    switch (section) {
        case 'in-progress':
            return 'Generating document preview';
        case 'needs-attention':
            return 'Document preview failed';
        case 'ready':
            return 'Document preview generated';
        case 'earlier':
            return 'Document preview generated';
    }
}

export function activityExportTitle(
    section: ActivitySection,
    skipped: boolean,
    exportKind: 'documents' | 'selected-documents' | 'pack' | null | undefined
): string {
    if (exportKind === 'selected-documents') {
        switch (section) {
            case 'in-progress':
                return 'Preparing selected documents';
            case 'needs-attention':
                return 'Selected document download needs attention';
            case 'ready':
            case 'earlier':
                return 'Selected documents ready';
        }
    }
    if (exportKind === 'pack') {
        if (skipped) return 'Pack export skipped';
        switch (section) {
            case 'in-progress':
                return 'Exporting pack';
            case 'needs-attention':
                return 'Pack export failed';
            case 'ready':
            case 'earlier':
                return 'Pack exported';
        }
    }

    if (skipped) return 'Document export skipped';
    switch (section) {
        case 'in-progress':
            return 'Exporting documents';
        case 'needs-attention':
            return 'Document export failed';
        case 'ready':
            return 'Documents exported';
        case 'earlier':
            return 'Documents exported';
    }
}
